// src/js/core/translateParagraphs.js

// Function to get the raw text from a paragraph (stripping out the spans)
function getParagraphText(paragraphContainer) {
  return Array.from(paragraphContainer.querySelectorAll(".word"))
    .map((span) => span.textContent)
    .join(" ");
}

// Function to translate paragraph using our Netlify function
async function translateParagraph(text, fromLanguage) {
  try {
    const response = await fetch("/.netlify/functions/translate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: text,
        fromLanguage: fromLanguage,
        isParagraph: true,
      }),
    });

    if (!response.ok) {
      throw new Error(`Translation API error: ${response.status}`);
    }

    const data = await response.json();
    return data.translation;
  } catch (error) {
    console.error("Translation error:", error);
    return null;
  }
}

// Initialize event listeners for translate buttons
export function initializeTranslateButtons() {
  document.getElementById("output").addEventListener("click", async (e) => {
    if (!e.target.matches(".translate-btn")) return;

    const button = e.target;
    const paragraphContainer = button.closest(".paragraph-container");

    // Create and insert spinner in place of button
    const spinner = document.createElement("div");
    spinner.className = "spin";
    button.parentNode.replaceChild(spinner, button);

    try {
      const text = getParagraphText(paragraphContainer);
      const language = document.getElementById("language-select").value;
      const translation = await translateParagraph(text, language);

      if (translation) {
        // Create and insert translation element
        const translationElement = document.createElement("p");
        translationElement.className = "paragraph-translation";
        translationElement.textContent = translation;
        paragraphContainer.insertAdjacentElement("afterend", translationElement);

        // Remove the spinner
        spinner.remove();
      } else {
        // If translation failed, restore original button
        spinner.parentNode.replaceChild(button, spinner);
      }
    } catch (error) {
      console.error("Translation process error:", error);
      // Restore original button on error
      spinner.parentNode.replaceChild(button, spinner);
    }
  });
}
